import GenerateFile from './generateFile'
import GenerateFileFromBranch from './generateFileFromBranch'
import CallWithoutFile from './callWithoutFile'
import Simple from './simple'
import UploadFile from './uploadFile'
import UploadFileToBranch from './uploadFileToBranch'
import SelectNode from './selectNode'
import SequencedForm from './sequencedForm'
import TrainML from './ML/trainML'
import PredictML from './ML/predictML'
import StatusML from './ML/statusML'
import SyncProject from './syncProject'
import JSONEditor from './jsonEditor'

import sample from './sample'

core = (componentConf) -> {
  'generate_file':               GenerateFile
  'generate_file_from_branch':   GenerateFileFromBranch
  'call_without_file':           CallWithoutFile
  'simple':                      Simple
  'upload_file':                 UploadFile
  'upload_file_to_branch':       UploadFileToBranch
  'select_node':                 SelectNode(componentConf)
  'sequenced_form':              SequencedForm
  'train_ml':                    TrainML
  'predict_ml':                  PredictML
  'status_ml':                   StatusML
  'sync_project':                SyncProject
  'json_editor':                 JSONEditor
}

registries = {
  core,
  sample
}

hasNamespace = (key, namespace) ->
  key.replace(namespace + '/', '') isnt key

export default getTemplate = (key, componentConf) ->
  for namespace, registry of registries
    if hasNamespace(key, namespace)
      return registry(componentConf)[key.replace("#{ namespace }/", '')]

  if core()[key]
    return core(componentConf)[key]

  throw new Error("There is no template #{ key }")
